import _extends from "@babel/runtime-corejs3/helpers/extends";import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";var _excluded = ["width"];import React from 'react';
import { SICSelect } from "../..";
import { INPUT_OPTIONS_SIZES } from "../../../utils/forms/dynamicFormsHelpers";


var SICSelectInputOption = function SICSelectInputOption(_ref)


{var _ref$width = _ref.width,width = _ref$width === void 0 ? 'large' : _ref$width,props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SICSelect, _extends({}, props, { width: INPUT_OPTIONS_SIZES[width] }));
};

export default SICSelectInputOption;
//# sourceMappingURL=index.js.map